<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import { ChevronRightIcon } from 'lucide-vue-next';
  import type { PaginationNextProps } from 'reka-ui';
  import { PaginationNext, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import type { ButtonVariants } from '@/components/ui/button';
  import { buttonVariants } from '@/components/ui/button';
  import { cn } from '@/lib/utils';

  const props = withDefaults(
    defineProps<
      PaginationNextProps & {
        size?: ButtonVariants['size'];
        class?: HTMLAttributes['class'];
      }
    >(),
    {
      size: 'default',
    },
  );

  const delegatedProps = reactiveOmit(props, 'class', 'size');
  const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <PaginationNext
    data-slot="pagination-next"
    :class="
      cn(
        buttonVariants({ variant: 'outline', size }),
        'size-10 p-0',
        props.class,
      )
    "
    v-bind="forwarded"
  >
    <slot>
      <ChevronRightIcon class="size-4" />
    </slot>
  </PaginationNext>
</template>
